<template>
  <div class="flex h-full">
    <PageSidebar
      title="Beta Features"
      :items="sidebarItems"
    />

    <!-- Tab Content -->
    <div class="flex-1 h-full overflow-x-auto">
      <RouterView />
    </div>
  </div>
</template>

<script>
import { RouterView } from 'vue-router'
import { FEATURES } from '@/constants/features'
import PageSidebar from '@/components/widgetcomponents/library/PageSidebar.vue'

export default {
  name: 'BetaView',
  components: {
    RouterView,
    PageSidebar,
  },
  computed: {
    sidebarItems() {
      return [
        { id: 'agent', label: 'Agent', to: '/beta/agent', canAccess: FEATURES.MODULE_ADMIN },
        { id: 'metric-test', label: 'Metric Test', to: '/beta/metric-test', canAccess: FEATURES.MODULE_ADMIN },
        { id: 'leverage-analysis', label: 'Leverage Analysis', to: '/beta/leverage-analysis', canAccess: FEATURES.MODULE_PORTFOLIO },
        { id: 'entity-classification', label: 'Entity Classification', to: '/beta/entity-classification', canAccess: FEATURES.MODULE_PORTFOLIO },
        { id: 'attribution', label: 'Attribution', to: '/beta/attribution', canAccess: FEATURES.MODULE_PORTFOLIO },
        // Impact Analytics promoted out of /beta to /insight/impact-analytics.
        { id: 'cclf-report', label: 'CCLF Monthly Report', to: '/beta/cclf-report', canAccess: FEATURES.MODULE_PORTFOLIO },
        {
          id: 'outreach',
          label: 'Outreach',
          canAccess: FEATURES.MODULE_OUTREACH,
          children: [
            { id: 'outreach-agents', label: 'Agents', to: '/beta/outreach/agents' },
            { id: 'outreach-call', label: 'Call', to: '/beta/outreach/call' },
            { id: 'outreach-campaigns', label: 'Campaigns', to: '/beta/outreach/campaigns' },
            { id: 'outreach-reporting', label: 'Reporting', to: '/beta/outreach/reporting' },
          ],
        },
        { id: 'rostering-test', label: 'Rostering Test', to: '/beta/rostering-test' },
        { id: 'growth', label: 'Growth', to: '/beta/growth', canAccess: FEATURES.MODULE_GROWTH },
        // Support promoted out of /beta to the top-level /support workspace (items 7+8).
        { id: 'intelligence-studio', label: 'Intelligence Studio', to: '/beta/intelligence-studio' },
        { id: 'constraint-analysis', label: 'Constraint Analysis', to: '/beta/constraint-analysis' },
      ]
    },
  },
}
</script>
